import { DrawerDivider } from "../layout/RightDrawer.style";
import { AboutPatient } from "../message/messageHeader/privateChatHeader/privateChatHeaderTabs/info/AboutPatient";
import { FEATURES, IUserInfo, USER_TYPE } from "@home-health-notify/domain";
import { KnowMeMore } from "../message/messageHeader/privateChatHeader/privateChatHeaderTabs/info/KnowMeMore";
import React, { useContext } from "react";
import AssignedPatients from "./assignedPatients/AssignedPatients";
import {
  AssignedPatientsProvider,
  OrganizationContext,
  useUserMedia,
} from "hhn-commons";
import { MediaDocumentInfo } from "./tabs/info/common/MediaDocumentInfo";

const PrivateChatInfo = ({ userInfo }: { userInfo: IUserInfo }) => {
  const { userMedia } = useUserMedia();
  const { selectedOrgUser } = useContext(OrganizationContext);
  const hasAccess = selectedOrgUser?.hasAccess(FEATURES.VIEW_ASSIGNED_PATIENTS);

  const showAssignedPatients =
    hasAccess &&
    (userInfo.type === USER_TYPE.ADMIN ||
      userInfo.type === USER_TYPE.USER ||
      userInfo.type === USER_TYPE.STAFF);

  return (
    <AssignedPatientsProvider>
      <DrawerDivider />
      <AboutPatient userInfo={userInfo} />
      <DrawerDivider />
      <MediaDocumentInfo mediaList={userMedia} />
      <DrawerDivider />
      {showAssignedPatients && (
        <>
          <AssignedPatients userInfo={userInfo} />
          <DrawerDivider />
        </>
      )}
      <KnowMeMore userInfo={userInfo} />
      <DrawerDivider />
    </AssignedPatientsProvider>
  );
};

export default PrivateChatInfo;
